// src/services/api.js
const API_BASE_URL = 'https://jj23pthetj.execute-api.us-east-1.amazonaws.com/prod';

export const api = {
  // Observations
  startObservationsExecution: async (data) => {
    const response = await fetch(`${API_BASE_URL}/observations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    return response.json();
  },
  
  getObservationsExecutionStatus: async (executionId) => {
    // Use the correct endpoint for checking execution status
    const response = await fetch(`${API_BASE_URL}/observations-sf/execution/${executionId}`, {
      method: 'GET',  // Use GET for status checks
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    return response.json();
  },
    
  // Trendså
  startTrendsExecution: async () => {
    const response = await fetch(`${API_BASE_URL}/trends-sf`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({})
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    return response.json();
  },
  
  getTrendsExecutionStatus: async (executionId) => {
    const response = await fetch(`${API_BASE_URL}/trends-sf/execution/${executionId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    return response.json();
  },

  validateTrends: async (trends) => {
    const response = await fetch(`${API_BASE_URL}/validate-trends`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ trends })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    return response.json();
  },
  
  // Announcements
  getAnnouncements: async () => {
    const response = await fetch(`${API_BASE_URL}/announcements`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({})
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    return response.json();
  }
};
